// customers stream: customer/policy CRUD keys. Merged into the app dictionary by locales/index.ts.
export const en: Record<string, string> = {
  "customers.kind": "Customer type",
  "customers.kind.person": "Person",
  "customers.kind.business": "Business",
  "customers.businessName": "Business name",
  "customers.imported": "Imported",
  "customers.sample": "Sample",
  "customers.address": "Address",
  "customers.address.line1": "Street address",
  "customers.address.line2": "Apt / suite",
  "customers.address.city": "City",
  "customers.address.state": "State",
  "customers.address.zip": "ZIP",
  "customers.dob": "Date of birth",
  "customers.edit": "Edit",
  "customers.editTitle": "Edit customer",
  "customers.saved": "Customer saved",
  "customers.noChanges": "Nothing changed",
  "customers.phone2": "Second phone",
  "customers.tags": "Tags",
  "customers.tagsHelp": "Comma separated, e.g. VIP, referral",
  "customers.ownerNone": "No owner",
  "customers.status": "Status",
  "customers.contactSection": "Contact",
  "customers.business.title": "Business profile",
  "customers.business.help": "Shared by the commercial form workflows (125, 126, 130, 131, 140). Leave anything unknown blank.",
  "customers.business.legalName": "Legal name",
  "customers.business.dba": "DBA",
  "customers.business.entityType": "Entity type",
  "customers.business.entity.sole_proprietor": "Sole proprietor",
  "customers.business.entity.partnership": "Partnership",
  "customers.business.entity.llc": "LLC",
  "customers.business.entity.corporation": "Corporation",
  "customers.business.entity.s_corp": "S corporation",
  "customers.business.entity.nonprofit": "Nonprofit",
  "customers.business.entity.other": "Other",
  "customers.business.fein": "FEIN (optional)",
  "customers.business.feinHelp": "Leave blank if unknown. Never enter a Social Security number.",
  "customers.business.naics": "NAICS code",
  "customers.business.description": "Description of operations",
  "customers.business.yearStarted": "Year started",
  "customers.business.employeesFullTime": "Full-time employees",
  "customers.business.employeesPartTime": "Part-time employees",
  "customers.business.annualRevenue": "Annual revenue ($)",
  "customers.business.annualPayroll": "Annual payroll ($)",
  "customers.business.website": "Website",
  "customers.business.contactName": "Primary contact",
  "customers.business.contactTitle": "Contact title",
  "customers.versionConflict": "Someone else changed this customer. Reload to see the latest.",
  "policies.add": "Add policy",
  "policies.edit": "Edit policy",
  "policies.added": "Policy added",
  "policies.saved": "Policy saved",
  "policies.number": "Policy number",
  "policies.expiration": "Expiration",
  "policies.priorPremium": "Prior term premium",
  "policies.billing": "Billing",
  "policies.billing.direct": "Direct bill",
  "policies.billing.agency": "Agency bill",
  "policies.carrierHint": "Type any carrier; your configured carriers are suggested.",
  "policies.pickCustomer": "Which customer is this policy for?",
  "policies.pickCustomerHelp": "Search by name, phone or email, then pick one.",
  "policies.source.sample": "Sample book",
  "policies.source.carrier_demo": "Carrier (demo)",
  "policies.externalIds": "Source ids",
  "policies.manualNote": "Entered by hand. It is logged on the customer file.",
  "policies.premiumHelp": "Dollars, e.g. 842.50",
};

export const es: Record<string, string> = {
  "customers.kind": "Tipo de cliente",
  "customers.kind.person": "Persona",
  "customers.kind.business": "Negocio",
  "customers.businessName": "Nombre del negocio",
  "customers.imported": "Importado",
  "customers.sample": "Muestra",
  "customers.address": "Dirección",
  "customers.address.line1": "Calle y número",
  "customers.address.line2": "Apto / suite",
  "customers.address.city": "Ciudad",
  "customers.address.state": "Estado",
  "customers.address.zip": "Código postal",
  "customers.dob": "Fecha de nacimiento",
  "customers.edit": "Editar",
  "customers.editTitle": "Editar cliente",
  "customers.saved": "Cliente guardado",
  "customers.noChanges": "No hubo cambios",
  "customers.phone2": "Segundo teléfono",
  "customers.tags": "Etiquetas",
  "customers.tagsHelp": "Separadas por coma, p. ej. VIP, referido",
  "customers.ownerNone": "Sin responsable",
  "customers.status": "Estado",
  "customers.contactSection": "Contacto",
  "customers.business.title": "Perfil del negocio",
  "customers.business.help": "Lo usan los flujos de formularios comerciales (125, 126, 130, 131, 140). Deje en blanco lo que no sepa.",
  "customers.business.legalName": "Razón social",
  "customers.business.dba": "Nombre comercial",
  "customers.business.entityType": "Tipo de entidad",
  "customers.business.entity.sole_proprietor": "Persona física",
  "customers.business.entity.partnership": "Sociedad",
  "customers.business.entity.llc": "LLC",
  "customers.business.entity.corporation": "Corporación",
  "customers.business.entity.s_corp": "Corporación S",
  "customers.business.entity.nonprofit": "Sin fines de lucro",
  "customers.business.entity.other": "Otro",
  "customers.business.fein": "FEIN (opcional)",
  "customers.business.feinHelp": "Déjelo en blanco si no lo sabe. Nunca ingrese un número de Seguro Social.",
  "customers.business.naics": "Código NAICS",
  "customers.business.description": "Descripción de operaciones",
  "customers.business.yearStarted": "Año de inicio",
  "customers.business.employeesFullTime": "Empleados de tiempo completo",
  "customers.business.employeesPartTime": "Empleados de medio tiempo",
  "customers.business.annualRevenue": "Ingresos anuales ($)",
  "customers.business.annualPayroll": "Nómina anual ($)",
  "customers.business.website": "Sitio web",
  "customers.business.contactName": "Contacto principal",
  "customers.business.contactTitle": "Puesto del contacto",
  "customers.versionConflict": "Alguien más cambió este cliente. Recargue para ver lo último.",
  "policies.add": "Agregar póliza",
  "policies.edit": "Editar póliza",
  "policies.added": "Póliza agregada",
  "policies.saved": "Póliza guardada",
  "policies.number": "Número de póliza",
  "policies.expiration": "Vencimiento",
  "policies.priorPremium": "Prima del periodo anterior",
  "policies.billing": "Facturación",
  "policies.billing.direct": "Cobro directo",
  "policies.billing.agency": "Cobro por agencia",
  "policies.carrierHint": "Escriba cualquier aseguradora; se sugieren las configuradas.",
  "policies.pickCustomer": "¿Para qué cliente es esta póliza?",
  "policies.pickCustomerHelp": "Busque por nombre, teléfono o correo y elija uno.",
  "policies.source.sample": "Libro de muestra",
  "policies.source.carrier_demo": "Aseguradora (demo)",
  "policies.externalIds": "Ids de origen",
  "policies.manualNote": "Capturada a mano. Queda registrada en el expediente.",
  "policies.premiumHelp": "En dólares, p. ej. 842.50",
};
